// react imports
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// CUSTOM COMPONENTS

import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

//import { pdfjs } from "react-pdf";

import { MDBPagination, MDBPaginationItem, MDBPaginationLink } from "mdb-react-ui-kit";

//import * as pdfjsLib from 'pdfjs-dist/build/pdf'

//pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

//pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

const PdfVieWerPage = (props) => {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pagination, setPagination] = useState();
  const [localWidth, setLocalWidth] = useState();
  const location = useLocation();
  const filename = location.state?.filename;

  useEffect(() => {
    setPageNumber(1);
  }, [filename]);

  const handleWindowSizeChange = () => {
    setLocalWidth(document.getElementById("pdf-container").clientWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    handleWindowSizeChange();
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 200);
    if (numPages > 1) {
      let array = [];
      for (let i = 0; i < numPages; i++) {
        array.push(i + 1);
      }

      let localPagination = array.map((k, n) => {
        return (
          <MDBPaginationItem key={n} active={pageNumber === k} aria-current="page">
            <MDBPaginationLink
              onClick={() => {
                setPageNumber(k);
              }}
            >
              {k}
              {pageNumber === k && <span className="visually-hidden">(current)</span>}
            </MDBPaginationLink>
          </MDBPaginationItem>
        );
      });
      setPagination(localPagination);
    }
  }, [pageNumber, filename, numPages]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function onDocumentLoadError(error) {
    console.log(error);
    setNumPages(undefined);
    setPagination(undefined);
  }

  console.log(`${process.env.REACT_APP_BACKEND_URL}/storage/pdf/${filename}.pdf`);

  return (
    <div className="px-2">
      <div id="pdf-container">
        <Document
          file={`${process.env.REACT_APP_BACKEND_URL}/storage/pdf/${filename}.pdf`}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          error={"Hiányzó PDF fájl"}
          loading={"Fájl betöltése"}
        >
          <Page
            pageNumber={pageNumber}
            renderTextLayer={true}
            renderAnnotationLayer={false}
            scale={1}
            width={localWidth}
          />
        </Document>

        {pagination && (
          <div className="d-flex align-items-center justify-content-center">
            <nav aria-label="Page navigation example">
              <MDBPagination className="mb-0">
                {pageNumber > 1 && (
                  <MDBPaginationItem>
                    <MDBPaginationLink
                      onClick={() => {
                        setPageNumber(pageNumber - 1);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">«</span>
                    </MDBPaginationLink>
                  </MDBPaginationItem>
                )}

                {pagination}

                {pageNumber < numPages && (
                  <MDBPaginationItem>
                    <MDBPaginationLink
                      onClick={() => {
                        setPageNumber(pageNumber + 1);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      aria-label="Next"
                    >
                      <span aria-hidden="true">»</span>
                    </MDBPaginationLink>
                  </MDBPaginationItem>
                )}
              </MDBPagination>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfVieWerPage;
